import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { mapCandidateAttachments } from 'features/sendouts/common/utils';
import { Attachments } from 'features/sendouts/components/shared';
import { AttachmentsVariant } from 'features/sendouts/components/shared/Attachments';
import { TabLoaderContainer } from 'features/sendouts/components/shared/DetailsTabs';
import { ATTACHMENTS_CATEGORIES } from 'features/sendouts/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { CandidateFileCategoriesWithSendout } from 'UI/components/organisms/sendouts/utils';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { Endpoints } from 'UI/constants/endpoints';

const ATTACHMENT_CATEGORIES = [ATTACHMENTS_CATEGORIES.resume, ATTACHMENTS_CATEGORIES.other];

export const SendoverAttachmentsTabContent = ({ sendoverId }) => {
  const { Status } = useFetchWithStatusV2({
    endpoint: sendoverId ? `${Endpoints.Sendouts}/${sendoverId}` : null, // TODO: use sendout attachments endpoint when it is available. By now is using legacy sendout details endpoint which includes attachments data.
    apiVersion: 1
  });

  return (
    <Status
      loading={
        <TabLoaderContainer>
          <CircularProgress />
        </TabLoaderContainer>
      }
      success={data => {
        const attachments = mapCandidateAttachments(data.attachments);
        return (
          <Attachments
            categories={ATTACHMENT_CATEGORIES}
            categoryIdMap={CandidateFileCategoriesWithSendout}
            files={attachments}
            variant={AttachmentsVariant.Readonly}
          />
        );
      }}
      error={<EmptyPlaceholder title={strings.sendoutsV2.drawers.tabs.status.error} />}
    />
  );
};
